export default __webpack_public_path__ + "static/media/processing.779ca435.svg";